export default {
  name: "EditCategory",
  props: ["editedCategory", "categories", "global", "isPoiAdmin"],
  computed: {
    mappingFields() {
      return this.$store.state.mappingFields;
    }
  }
};
